export default "__VITE_ASSET__d0f36f80__"